import type { EvoValue } from '../../types';

export function formatEvoValue(value?: EvoValue | null, options?: { signed?: boolean; compact?: boolean }) {
  if (!value) return 'n/a';
  const n = value.value;
  const signed = options?.signed && n > 0 ? '+' : '';
  if (value.unit === 'USD') return `${signed}$${Math.abs(n).toLocaleString(undefined, { maximumFractionDigits: 0 })}${n < 0 ? ' loss' : ''}`;
  if (value.unit.includes('rate') || value.unit.includes('margin')) return `${signed}${(n * 100).toFixed(1)}%`;
  if (value.unit.includes('points')) return `${signed}${n.toFixed(options?.compact ? 1 : 3)} pts`;
  if (value.unit === 'days') return `${n.toFixed(0)} days`;
  return `${signed}${Number.isInteger(n) ? n.toFixed(0) : n.toFixed(3)} ${value.unit}`;
}

export function shortDate(iso?: string | null) {
  return iso ? iso.slice(0, 10) : 'n/a';
}
